export function isPracticeLabRequired(
  accessioningType?: string | null
): boolean {
  return accessioningType !== "tc_only" && accessioningType !== "pass_through";
}

export type RequiredCaseInfoField =
  | "physicianId"
  | "accountId"
  | "locationId"
  | "procedureId"
  | "dateReceived"
  | "dateCollected"
  | "externalCaseNumber"
  | "consultationReason";

export function getRequiredCaseInfoFields(
  accessioningType?: string | null
): RequiredCaseInfoField[] {
  const fields: RequiredCaseInfoField[] =
    accessioningType === "tc_only"
      ? ["physicianId", "procedureId", "dateReceived", "dateCollected"]
      : [
          "physicianId",
          "accountId",
          "locationId",
          "procedureId",
          "dateReceived",
          "dateCollected",
        ];

  if (
    accessioningType === "consultation" ||
    accessioningType === "pass_through" ||
    accessioningType === "tc_only"
  ) {
    fields.push("externalCaseNumber");
  }
  if (accessioningType === "consultation") {
    fields.push("consultationReason");
  }
  return fields;
}
